<!-- 
  <app-formadd [config]="formConfig" (submitted)="reloadTable()"></app-formadd>
  <h2>{{ title }}</h2>
  <p>This are the users of the App</p> -->
  <!-- 👇 simply use the child selector -->
  <app-update-add-table
  [config]="config"
  [element_name]="element_name"
  [path]="path" 
  [form_add]="showFormAdd"
  [showDeleteButton]="showDeleteButton"
  [showUpdateButton]="showUpdateButton"
  
  [title]="title" 
  [description]="description" >
  <app-update-add-table>
